import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

const SuccessDialog = ({ successOpen, setSuccessOpen, editIndex }) => {
  return (
    <Dialog
      open={successOpen}
      onClose={() => setSuccessOpen(false)}
      maxWidth="sm"
      fullWidth
      sx={{ borderRadius: "12px" }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottom: "1px solid #E7E8E9",
          padding: "10px 24px",
        }}
      >
        <Typography variant="h6">Success</Typography>
        <IconButton edge="end" color="inherit" onClick={() => setSuccessOpen(false)}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div className="my-4 text-center">
          <img
            src="/images/succesfull-check.png"
            alt="Success"
            style={{ width: 60, height: 60, marginBottom: 16 }}
          />
          <p>{editIndex !== null ? "User updated successfully." : "User created successfully."}</p>
        </div>
      </DialogContent>
      <DialogActions
        sx={{
          padding: "1rem",
          borderTop: "1px solid #E7E8E9",
          justifyContent: "center",
        }}
      >
        <button className="btn BlueBtn" onClick={() => setSuccessOpen(false)}>
          OK
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;